// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"TermsAndConditions_pageWrapper__28mQF","pageContainer":"TermsAndConditions_pageContainer__3waOm","pageSection":"TermsAndConditions_pageSection__1W0UN"};